
import Header from "./header";
import SideMenu from "./sidemenu";

const BasePageContainer = ({ children }) => {

  const renderSideMenu = () => {
    return <SideMenu />;
  };

  return (
    <>
      <Header />
      {renderSideMenu()}
      {children}
    </>
  );
};

export default BasePageContainer;
